/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-11-19 15:58:20
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-01-06 10:23:57
 * @FilePath: \vue-hepha-order\src\api\kpiDailyReportApi.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Data } from '@/api/axiosFun.js';

class KpiDailyReportApi {
    static getInstance() {
        if (!this.instance) this.instance = new KpiDailyReportApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取销量列表
    async getSaleList (param){
        let url = `/api/report/kpi/sales/orders`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取发货列表
    async getShipList (param){
        let url = `/api/report/kpi/mes/stock`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 导出订单明细
    async exportOrderDetail (param){
        let url = `/api/report/kpi/export/orders`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 导出erp出货
    async exportERPShip (param){
        let url = `/api/report/kpi/export/shipments`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 导出mes出货
    async exportMESShip (param){
        let url = `/api/report/kpi/export/mes/shipments`
        let result = await this.getData(url,param,'GET')
        return result
    }

    

}

export {
    KpiDailyReportApi
}